import React, {useRef, useEffect} from 'react';
import {Iterable} from 'immutable';
import tablesort from 'tablesort';
import {renderSortableTableHtml} from './renderSortableTableHtml';
import './sortable-table.scss';

/**
 * tablesort extensions modify the Tablesort object, so we need to attach it to the global
 * scope directly. Since sorting doesn't happen on the server, we only need to do this on the client.
 */
global.Tablesort = tablesort;
import('tablesort/src/sorts/tablesort.number');
import('tablesort/src/sorts/tablesort.date');
import('tablesort/src/sorts/tablesort.monthname');

interface Props {
  content: {
    text: string;
  };
  hasTotal: boolean;
}

export default function SortableTable({content: contentProp = {text: ''}, hasTotal}: Props) {
  const wrapperNode = useRef<HTMLDivElement | null>(null);
  const sortRef = useRef<any>(null);

  const init = () => {
    const table = wrapperNode.current?.firstElementChild;
    if (!table?.nodeName || table.nodeName !== 'TABLE') {
      return;
    }
    sortRef.current = tablesort(table);
  };

  useEffect(() => {
    init();
  }, []);

  useEffect(() => {
    if (!sortRef.current) {
      init();
    } else {
      sortRef.current.refresh();
    }
  }, [contentProp]);

  const content = Iterable.isIterable(contentProp) ? (contentProp as any).toJS() : contentProp;
  const text = renderSortableTableHtml(content.text, hasTotal);
  return (
    <div className='sortable-table' ref={wrapperNode} dangerouslySetInnerHTML={{__html: text}} />
  );
}
